import script from "./us.vue?vue&type=script&setup=true&lang=ts"
export * from "./us.vue?vue&type=script&setup=true&lang=ts"

import "./us.vue?vue&type=style&index=0&id=142f11ba&lang=scss"

const __exports__ = script;

export default __exports__